import * as React from 'react';
export const rlusdSvg = React.forwardRef(function rlusdSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2C68F6',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.487 18.44c-.777-.451-1.653-.58-2.521-.61-.729-.024-1.814-.49-1.814-1.825a1.844 1.844 0 0 1 1.814-1.826c.869-.03 1.744-.16 2.521-.61A4.589 4.589 0 0 0 25.78 9.59a4.601 4.601 0 0 0-2.299-3.976 4.607 4.607 0 0 0-4.593.001 4.601 4.601 0 0 0-2.299 3.976c0 .89.317 1.71.723 2.471.339.64.511 1.826-.655 2.498a1.841 1.841 0 0 1-2.488-.682c-.456-.73-1.014-1.42-1.78-1.86A4.596 4.596 0 0 0 6.115 13.7a4.594 4.594 0 0 0 6.274 6.277c.771-.446 1.323-1.13 1.78-1.86.376-.61 1.31-1.364 2.488-.682a1.848 1.848 0 0 1 .654 2.497c-.405.761-.72 1.58-.72 2.471a4.596 4.596 0 1 0 6.897-3.98v.017Z',
      fill: '#fff',
    }),
  );
});
rlusdSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rlusd = {
  category: 'brand',
  colorable: false,
  name: 'rlusd',
  svg: rlusdSvg,
};
